﻿window.$ = window.jQuery = require("jquery");
require("bootstrap");
window.notification = require("./notification");
window.common = require("./common");

(function ($) {
  window.notification.init();
  window.common.init();

  // Added global $ for console debug
  window.$ = $;

  const moduleElements = document.querySelectorAll("[data-module]");

  for (let i = 0; i < moduleElements.length; i++) {
    const el = moduleElements[i];
    const name = el.getAttribute("data-module");

    const Module = require("./" + name);
    new Module(el);
  }
})(jQuery);
